export type Sinester = any

export interface SinesterType {
    _id?: string
    name?: string
    ebrokerId?: number
}

export interface InvolvedType {
    id?: number
    description?: string
}

export interface SinestersState {
    loading: boolean
    loadingdata: boolean
    loadingtypes: boolean
    resultsinester: string | null
    sinesters: Sinester[]
    sinestersForSelect: Sinester[]
    sinester: Sinester | null
    sinesterTypes: SinesterType[]
    total: number
    involvedTypes: InvolvedType[]
}

const initialState: SinestersState = {
    loading: false,
    loadingdata: false,
    loadingtypes: false,
    resultsinester: null,
    sinesters: [],
    sinestersForSelect: [],
    sinester: null,
    sinesterTypes: [],
    total: 0,
    involvedTypes: []
}

export const sinestersReducer = (state: SinestersState = initialState, action: { type: string; payload?: any }): SinestersState => {
    switch (action.type) {
        case "SINESTER_GETALL_SUCCESS":
            return {
                ...state,
                loading: false,
                sinesters: action.payload.sinesters as Sinester[],
                total: action.payload.total,
                resultsinester: null,
            }

        case "SINESTER_GETALLFORSELECT_SUCCESS":
            return {
                ...state,
                sinestersForSelect: action.payload as Sinester[],
                loading: false,
                resultsinester: null,
            }

        case "SINESTER_GET_SUCCESS":
            return {
                ...state,
                loading: false,
                sinester: action.payload.sinester as Sinester,
            }

        case "SINESTER_ADD_SUCCESS":
            return {
                ...state,
                loading: false,
                resultsinester: action.payload.message,
                sinester: action.payload.sinester as Sinester,
                sinesters: [...state.sinesters, action.payload.sinester as Sinester],
            }

        case "SINESTER_WRONG_SUCCESS":
            return {
                ...state,
                loading: false,
                resultsinester: action.payload.message,
            }

        case "SINESTER_EDIT_SUCCESS":
            return {
                ...state,
                loading: false,
                resultsinester: action.payload.message as string
            }

        case "SINESTER_RESET_RESULT":
            return {
                ...state,
                resultsinester: null,
            }

        case "SINESTER_LOADING":
            return {
                ...state,
                loading: true,
            }

        case "SINESTER_NOT_LOADING":
            return {
                ...state,
                loading: false,
            }
        case "SINESTERDATA_GET_SUCCESS":
            return {
                ...state,
                loadingdata: false,
                sinester: action.payload.sinester as Sinester,
            }

        case "SINESTERDATA_LOADING":
            return {
                ...state,
                loadingdata: true,
            }

        case "SINESTERDATA_NOT_LOADING":
            return {
                ...state,
                loadingdata: false,
            }

        case "SINESTERTYPE_GETALL_SUCCESS":
            return {
                ...state,
                sinesterTypes: action.payload.sinesterTypes as SinesterType[],
            }

        case 'INVOLVEDTYPE_GETALL_SUCCESS':
            return {
                ...state,
                involvedTypes: action.payload.involvedTypes as InvolvedType[],
            }

        case 'INVOLVEDTYPE_IMPORT_SUCCESS':
            return {
                ...state,
                involvedTypes: action.payload.involvedTypes as InvolvedType[],
                loadingtypes: false,
            }

        case "SINESTERTYPE_LOADING":
            return {
                ...state,
                loadingtypes: true,
            }

        case "SINESTERTYPE_NOT_LOADING":
            return {
                ...state,
                loadingtypes: false,
            }

        case 'SINESTERTYPE_IMPORT_SUCCESS':
            return {
                ...state,
                sinesterTypes: action.payload.sinesterTypes as SinesterType[],
                loadingtypes: false,
            }

        default:
            return state
    }
}
